import store from '../store'

const validateSesion = (keycloakFunction) =>{
  return new Promise((resolve, reject) => {

    if(!keycloakFunction.authenticated){
      keycloakFunction
        .init({onLoad:'login-required'})
        .success(() => {
          setAuthState(keycloakFunction)
          resolve()
        })
        .error(() => {
          reject("Error");
        });
    }
    else resolve()

  })
}


const setAuthState = (keycloakFunction)=>{

  const tokenParsed=keycloakFunction.tokenParsed

  console.log(tokenParsed)

  const auth={
    user: {
      fullName: tokenParsed.name,
      email: tokenParsed.email,
      preferred_username: tokenParsed.preferred_username
    },
    roles: tokenParsed.realm_access.roles
  }

  store.dispatch('security/authLogin',auth)

}


export default {
  validateSesion,
  setAuthState
}



// WEBPACK FOOTER //
// ./src/keycloakUtils/index.js